import React, { useEffect, useState } from "react";
import styled, { useTheme } from "styled-components";
import { useTranslate } from '@tolgee/react';
import { colors } from "../../Assets/styles/colors";
import { ReactComponent as CheckEmpty } from "../../Assets/iconsv2/generic/checkEmpty.svg";
import { ReactComponent as Check } from "../../Assets/iconsv2/generic/check.svg";
import { useGenericComponentsStateService } from "../../Context/GenericComponentsStateContext";
import { DARK_THEME, LIGHT_THEME } from "../../Constants/constantValues";
import LocalStorage from "../../Helpers/LocalStorage";

const AppearanceSettings = () => {
  const { setTheme, theme } = useGenericComponentsStateService();
  const [infoChanged, setInfoChanged] = useState(false);

  const themeColors = useTheme();

  const handleChangeTheme = (theme) => {
    setTheme(theme);
    document.documentElement.classList.toggle("dark");
    LocalStorage.setAppTheme(theme);
  };
  const { t } = useTranslate();
  return (
    <Container>
      <Header>
        <HeaderTitle>{t('settings.appearance')}</HeaderTitle>
      </Header>

      <ContentWrapper>
        <Content>
          <Group>
            <GroupSubtitle>
              {t('settings.appearance_description')}
            </GroupSubtitle>
          </Group>
          <Group>
            <GroupContentWrapper>
              <ThemeItem
                selected={theme === DARK_THEME}
                onClick={() => handleChangeTheme(DARK_THEME)}
              >
                {t('settings.dark_mode')}
                <CheckWrapper>
                  {theme === DARK_THEME ? (
                    <CheckedWrapper>
                      <Check />
                    </CheckedWrapper>
                  ) : (
                    <CheckEmptyWrapper>
                      <CheckEmpty />
                    </CheckEmptyWrapper>
                  )}
                </CheckWrapper>
              </ThemeItem>
              <ThemeItem
                selected={theme === LIGHT_THEME}
                onClick={() => handleChangeTheme(LIGHT_THEME)}
              >
                {t('settings.light_mode')}
                <CheckWrapper>
                  {theme === LIGHT_THEME ? (
                    <CheckedWrapper>
                      <Check />
                    </CheckedWrapper>
                  ) : (
                    <CheckEmptyWrapper>
                      <CheckEmpty />
                    </CheckEmptyWrapper>
                  )}
                </CheckWrapper>
              </ThemeItem>
            </GroupContentWrapper>
          </Group>
        </Content>
      </ContentWrapper>
    </Container>
  );
};

export default AppearanceSettings;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
`;
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 19px 16px;
  align-items: center;
  background: ${({ theme }) => theme.menu.background};
  border-bottom: 1px solid ${({ theme }) => theme.sidebar.borderColor};
  gap: 20px;
`;
const HeaderTitle = styled.h3`
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  letter-spacing: 0.04px;
  color: ${({ theme }) => theme.menu.primaryTextColor};
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px;
  background: ${({ theme }) => theme.menu.background};
  height: 100%;
  overflow: auto;
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin: 0 auto;
  max-width: 631px;
  width: 100%;
  overflow: hidden;
`;

const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const GroupContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.menu.groupContentBackground};
  border-radius: 4px;
  overflow: hidden;
`;

const ThemeItem = styled.h3`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 14px 16px;
  color: ${colors.listColor};
  color: ${({ selected, theme }) =>
    selected ? theme.menu.selectedTextColor : theme.menu.secondaryTextColor};
  background: ${({ selected, theme }) =>
    selected
      ? theme.menu.selectedOpionBackground
      : theme.menu.groupContentBackground};
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  cursor: pointer;
  gap: 10px;
  border-bottom: 1px solid ${({ theme }) => theme.sidebar.borderColor};
  &:last-child {
    border: none;
  }
`;

const GroupSubtitle = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.04px;
  vertical-align: middle;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
`;

const CheckWrapper = styled.div`
  display: flex;
  margin-left: auto;
  svg {
    fill: transparent;
    color: transparent;
  }
`;
const CheckedWrapper = styled.div`
  display: flex;
  svg {
    color: ${({ theme }) => theme.check.background};
    fill: ${({ theme }) => theme.check.checkSign};
  }
`;
const CheckEmptyWrapper = styled.div`
  display: flex;
  svg {
    color: ${({ theme }) => theme.check.border};
    stroke: ${({ theme }) => theme.check.checkSign};
  }
`;
